import { TimelineMax, Elastic, Expo } from 'gsap/TweenMax';
import { qs, qsa } from '@/scripts/utils';

const logoIn = (el) => {
  const logo = qs('.logo', el);
  const primaryText = qs('[js-introTextPrimary]', el);
  const primaryLetters = qsa('[data-letter]', primaryText);
  const SecondaryText = qs('[js-introTextSecondary]', el);
  const secondaryLetters = qsa('[data-letter]', SecondaryText);
  const paths = qsa('.cls-2', el);

  paths.forEach((element) => {
    element.style.strokeDasharray = element.style.strokeDashoffset = element.getTotalLength(); // eslint-disable-line
  });

  const tl = new TimelineMax({ paused: true });

  tl.add('start')
    .set(logo, { autoAlpha: 1 })
    .staggerFromTo(primaryLetters, 1.2, {
      yPercent: 100,
      skewX: -20,
      autoAlpha: 0,
      ease: Elastic.easeOut.config(0.8, 1),
    }, {
      yPercent: 0,
      skewX: 0,
      autoAlpha: 1,
      ease: Elastic.easeOut.config(0.8, 1),
    }, 0.08, 'start')
    .staggerFromTo(secondaryLetters, 1.2, {
      yPercent: 100,
      skewX: -20,
      autoAlpha: 0,
      ease: Elastic.easeOut.config(0.8, 1),
    }, {
      yPercent: 0,
      skewX: 0,
      autoAlpha: 1,
      ease: Elastic.easeOut.config(0.8, 1),
    }, 0.08, 'start+=0.2')
    .staggerTo(paths, 0.4, {
      strokeDashoffset: 0,
      stroke: '#454545',
      strokeWidth: 15,
      ease: Expo.Linear,
    }, 0.15, 'start+=0.5');

  return tl;
};


export default logoIn;



// WEBPACK FOOTER //
// ./src/scripts/timelines/logo.js